<template>
  <SymbolDigitTrial
    :legendData="legendData"
    :leadingImage="leadingImage"
    :trailingImage="trailingImage"
    :positiveButtonLabel="positiveButtonLabel"
    :negativeButtonLabel="negativeButtonLabel"
    @answered="handleAnswer"
  />
</template>

<script>
import { ntDate } from '@neurotrack/web-core'
import SymbolDigitTrial from '@/components/exams/symbol-digit/SymbolDigitTrial/SymbolDigitTrial.vue'
import essComponentProps from '@/mixins/essComponentProps'

export default {
  name: 'two_images_two_buttons_with_legend',
  mixins: [essComponentProps],
  components: { SymbolDigitTrial },
  data() {
    return {
      startTime: 0,
      trialComplete: false
    }
  },
  computed: {
    legendData() {
      const m = this.header.legend?.map(({ filename, value }) => ({
        url: this.getImageUrl(filename),
        value
      }))
      return m
    },
    leadingImage() {
      return this.getImageUrl(this.body.leading_image.filename)
    },
    trailingImage() {
      return this.getImageUrl(this.body.trailing_image.filename)
    },
    positiveButtonLabel() {
      return this.footer.leading_button?.text
    },
    negativeButtonLabel() {
      return this.footer.trailing_button?.text
    }
  },
  methods: {
    handleAnswer(response) {
      if (this.trialComplete) {
        return
      }

      this.trialComplete = true

      // there's no timeout for SD, so answer is either
      // 'equal' or 'unequal
      const perception = {
        exam_trial_id: this.trial.exam_trial_id,
        trial_start_time: this.startTime,
        trial_end_time: ntDate.now(),
        metadata: {
          trial_scoring_type: this.trial.trial_scoring_type
        },
        timeout: false, // this is required but not used anymore
        data: [
          {
            type: 'selection',
            value: response
          }
        ]
      }
      this.handleTrialResponse?.({
        perception,
        response
      })
    }
  },
  watch: {
    trial: {
      immediate: true,
      handler() {
        this.startTime = ntDate.now()
        this.trialComplete = false
      }
    }
  }
}
</script>
